import { ReactElement, useEffect, useState } from 'react'
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import MenuItemUI from './LayoutMenuItemUI'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useLocation, useNavigate } from 'react-router-dom'

interface Props {
  menu: MenuItemUI
  submenu: MenuItemUI[]
}

const LayoutMenuItem = (props: Props): ReactElement => {
  const { menu, submenu } = props

  const navigate = useNavigate()
  const location = useLocation()
  const submenuExists = props.submenu.length > 0

  const [open, setOpen] = useState<boolean>(false)

  const menuClick = () => {
    if (submenuExists) {
      setOpen(!open)
    } else {
      redirect(menu)
    }
  }

  const redirect = (item: MenuItemUI) => {
    if (item.url) {
      navigate(item.url)
    }
  }

  const isSelectedUrl = (url?: string): boolean => {
    return location.pathname === url
  }

  const isSubmenuSelected = () => {
    return submenu.find((item) => isSelectedUrl(item.url)) != null
  }

  useEffect(() => {
    if (isSubmenuSelected()) {
      setOpen(true)
    }
  }, [])

  return (
    <div>
      <List>
        <ListItem key={menu.id} disablePadding>
          <ListItemButton
            onClick={menuClick}
            selected={isSelectedUrl(menu.url)}
          >
            <ListItemIcon>{menu.icon}</ListItemIcon>
            <ListItemText primary={menu.text} />
            {submenuExists && (
              <>{open ? <ExpandLessIcon /> : <ExpandMoreIcon />}</>
            )}
          </ListItemButton>
        </ListItem>
      </List>
      {submenuExists && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List>
            {submenu.map((submenuItem) => (
              <ListItem key={submenuItem.text} disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => {
                    redirect(submenuItem)
                  }}
                  selected={isSelectedUrl(submenuItem.url)}
                >
                  <ListItemIcon>{submenuItem.icon}</ListItemIcon>
                  <ListItemText primary={submenuItem.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      )}
    </div>
  )
}

export default LayoutMenuItem
